import axios from "axios";
import { showToast } from "../hooks/showToast";
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL,
});
axiosInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem("accessToken");
  config.headers = {
    "Content-Type": "application/json",
  };
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let hasRedirected = false;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response && (response.status === 500 || response.status === 401)) {
      if (!hasRedirected) {
        // Set it synchronously to block further triggers
        hasRedirected = true;

        // Small delay can also help avoid racing
        setTimeout(() => {
          localStorage.clear();
          showToast("Please Wait...", "error");
          window.location.replace("/");
        }, 0);
      }

      // Keep promise pending so no further toast/errors are thrown
      return new Promise(() => {});
    } else if (response && response.status === 409) {
      return Promise.resolve(response);
    }

    return Promise.reject(error);
  }
);
